import React, { VFC } from 'react';
import styled from 'styled-components';
import { IIconProps } from './types';

const Wrapper = styled.div`
  display: block;
  margin: auto auto;
`;

const ArrowLeftIcon: VFC<IIconProps> = ({ color, size }) => (
  <Wrapper>
    <svg
      width={size}
      height={size}
      viewBox="-1 -2 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m9 6-6 6 6 6M3 12h18"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Wrapper>
);

export default ArrowLeftIcon;
